module.exports = __webpack_public_path__ + "static/media/0360_Small.aa70d9e1.jpg";